import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
export const colors = [
	'#fcba03',
	'#fa8c5c',
	'#45afed',
	'#7c5cdb',
	'#ce5cdb',
	'#db5c97',
	'#9fc934',
	'#60d17e',
];
const SummaryLeftBar = ({
	metricField,
	metricData,
	channels,
	metricInitialVal,
}) => {
	const [currentData, setCurrentData] = useState([]);
	const [rowsData, setRowsData] = useState('');
	const [metricFilter, setMetricFilter] = useState(metricInitialVal);
	const [channelNames, setChannelNames] = useState([]);
	useEffect(() => {
		if (metricData) {
			setRowsData(metricData.lineData);
		}
	}, [metricData]);

	// console.log('rowsData', rowsData);

	useEffect(() => {
		if (metricField && metricField[0] && rowsData) {
			const filterMetric = metricField[0].value;
			const filterChannel = channels[0] && channels[0].value;
			let data;
			if (filterMetric) {
				const chanNames = [];
				const allData = [];
				rowsData[filterMetric].filter((e) => {
					if (filterChannel) {
						if (e.label && e.label === filterChannel) {
							chanNames.push(e.label);
						}
						if (e.data && e.label === filterChannel) {
							const d = e.data.reduce((a, b) => a + b);
							allData.push(d);
						}
					} else {
						if (e.label) {
							chanNames.push(e.label);
						}
						if (e.data) {
							const d = e.data.reduce((a, b) => a + b);
							allData.push(d);
						}
					}
				});
				setMetricFilter(filterMetric);
				setChannelNames(chanNames);
				setCurrentData(allData);
			} else {
				const chanNames = [];
				const allData = [];
				setMetricFilter(metricInitialVal);
				rowsData[metricInitialVal] &&
					rowsData[metricInitialVal].filter((e) => {
						if (filterChannel) {
							if (e.label && e.label === filterChannel) {
								chanNames.push(e.label);
							}
							if (e.data && e.label === filterChannel) {
								const d = e.data.reduce((a, b) => a + b);
								allData.push(d);
							}
						} else {
							if (e.label) {
								chanNames.push(e.label);
							}
							if (e.data) {
								const d = e.data.reduce((a, b) => a + b);
								allData.push(d);
							}
						}
					});

				setChannelNames(chanNames);
				setCurrentData(allData);
			}
		}
	}, [rowsData, metricField, channels]);

	// console.log('currentData', currentData);
	// console.log('metricData', metricData);
	// console.log('channelNames', channelNames);
	// console.log('rowsData', rowsData);
	// const channelName = report.channels && report.channels[0].dropdown;
	const data = {
		labels: channelNames,
		datasets: [
			{
				axis: 'y',
				label: ``,
				fill: false,
				data: currentData,
				backgroundColor: [
					'rgba(252, 186, 3, 0.8)',
					'rgba(250, 140, 92, 0.8)',
					'rgba(69, 175, 237, 0.8)',
					'rgba(124, 92, 219, 0.8)',
					'rgba(206, 92, 219, 0.8)',
					'rgba(219, 92, 151, 0.8)',
					'rgba(159, 201, 52, 0.8)',
					'rgba(96, 209, 126, 0.8)',
				],
			},
		],
	};

	const options = {
		type: 'bar',
		indexAxis: 'y',
		maintainAspectRatio: false,
		plugins: {
			datalabels: { font: { size: 0 } },
			title: {
				display: true,
				text: metricFilter,
				font: {
					size: '20px',
				},
			},
			legend: {
				display: false,
			},
		},
	};

	return (
		<div>
			<Bar data={data} options={options} width={300} height={300} />
		</div>
	);
};

export default SummaryLeftBar;
